import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import jaherLogo from './logojaher-webreg.png';
import './Login.css';

const Login = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const { login } = useAuth();
    const navigate = useNavigate();

    const handleSubmit = (e) => {
        e.preventDefault();
        setError('');

        if (!username || !password) {
            setError('Por favor, complete todos los campos');
            return;
        }

        const result = login(username, password);

        if (result.success) {
            navigate('/dashboard');
        } else {
            setError(result.message);
        }
    };

    return (
        <div className="login-wrapper">
            <div className="login-container">
                {/* Left Side - Branding */}
                <div className="login-branding">
                    <div className="branding-content">
                        <div className="logo-section">
                            <div className="logo-icon">
                                <svg viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="50" cy="50" r="45" fill="#1E40AF" opacity="0.1" />
                                    <path d="M30 35 L50 25 L70 35 L70 65 L50 75 L30 65 Z" fill="#1E40AF" />
                                    <circle cx="50" cy="50" r="15" fill="white" />
                                    <path d="M45 50 L50 55 L60 42" stroke="#1E40AF" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" fill="none" />
                                </svg>
                            </div>
                            <h1 className="brand-name">Video Manager</h1>
                        </div>

                        <div className="platform-description">
                            <h2>Gestión Profesional de Contenido Audiovisual</h2>
                            <p>
                                Plataforma integral para organizar, administrar y controlar presentaciones
                                de video comercial. Diseñada para facilitar la gestión de contenido multimedia
                                con control total del administrador.
                            </p>

                            <div className="features-list">
                                <div className="feature-item">
                                    <span className="feature-icon">📊</span>
                                    <span>Gestión centralizada</span>
                                </div>
                                <div className="feature-item">
                                    <span className="feature-icon">🎬</span>
                                    <span>Control de presentaciones</span>
                                </div>
                                <div className="feature-item">
                                    <span className="feature-icon">📅</span>
                                    <span>Organización por fechas</span>
                                </div>
                                <div className="feature-item">
                                    <span className="feature-icon">🔒</span>
                                    <span>Acceso seguro</span>
                                </div>
                            </div>
                        </div>

                        {/* Powered by section removed as requested */}
                    </div>
                </div>

                {/* Right Side - Login Form */}
                <div className="login-form-section">
                    <div className="form-container">
                        <div className="login-logo-jaher-wrapper">
                            <img src={jaherLogo} alt="Jaher" className="login-logo-jaher" />
                        </div>
                        <div className="form-header">
                            <h2>Iniciar Sesión</h2>
                            <p>Ingrese sus credenciales para acceder al sistema</p>
                        </div>

                        <form onSubmit={handleSubmit} className="login-form">
                            {error && (
                                <div className="error-alert">
                                    <span className="error-icon">⚠️</span>
                                    <span>{error}</span>
                                </div>
                            )}

                            <div className="input-group">
                                <label htmlFor="username">Usuario</label>
                                <div className="input-wrapper">
                                    <span className="input-icon">👤</span>
                                    <input
                                        type="text"
                                        id="username"
                                        value={username}
                                        onChange={(e) => setUsername(e.target.value)}
                                        placeholder="Ingrese su usuario"
                                        autoComplete="username"
                                    />
                                </div>
                            </div>

                            <div className="input-group">
                                <label htmlFor="password">Contraseña</label>
                                <div className="input-wrapper">
                                    <span className="input-icon">🔒</span>
                                    <input
                                        type={showPassword ? 'text' : 'password'}
                                        id="password"
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                        placeholder="Ingrese su contraseña"
                                        autoComplete="current-password"
                                    />
                                    <button
                                        type="button"
                                        className="toggle-password"
                                        onClick={() => setShowPassword(!showPassword)}
                                        tabIndex="-1"
                                    >
                                        {showPassword ? '👁️' : '👁️‍🗨️'}
                                    </button>
                                </div>
                            </div>

                            <button type="submit" className="login-button">
                                Iniciar Sesión
                            </button>
                        </form>


                    </div>
                </div>
            </div>
        </div>
    );
};

export default Login;
